import * as ActionTypes from "services/state/action-types"
import is from "ramda/src/is"

const NEGOTIATION_STATE = {
  invoices: [],
  products: [],
  numberPlots: null,
  dueDateOptions: [],
  parcelingData: null,
  paymentUrl: null,
  card: null,
  approved: null,
  loader: false,
  error: false,
  errorCalc: false,
  selectedInvoices: []
}

export function negotiation(state = NEGOTIATION_STATE, action) {
  switch (action.type) {
    case ActionTypes.GET_INVOICE_NEGOTIATION:
      return { ...NEGOTIATION_STATE, loader: true }

    case ActionTypes.GET_INVOICE_NEGOTIATION_SUCCESS:
      return {
        ...state,
        invoices: action.payload.data,
        products: formatProducts(action.payload.data),
        loader: false
      }

    case ActionTypes.GET_CALCULATE_NUMBER_PLOTS_SUCCESS:
      return {
        ...state,
        numberPlots: formatNumberPlots(action.payload.data.resultData)
      }

    case ActionTypes.GET_INSTALLMENTS_SUCCESS:
      return {
        ...state,
        numberPlots: formatInstallmentsOptions(action.payload.data),
        dueDateOptions: formatDateOptions(action.payload.data)
      }

    case ActionTypes.SET_INVOICES_SELECTED_NEGOTIATION:
      return {
        ...state,
        selectedInvoices: action.payload.invoicesNegotiation
      }

    case ActionTypes.GET_CALC:
      return { ...state, loader: true }

    case ActionTypes.GET_STATUS_CALC:
      return { ...state, loader: true }

    case ActionTypes.GET_STATUS_CALC_FAIL:
      return {
        ...state,
        dueDateOptions: [],
        numberPlots: null,
        loader: false,
        error: true
      }

    case ActionTypes.GET_RESULT_CALC:
      return { ...state, loader: true }

    case ActionTypes.GET_RESULT_CALC_SUCCESS: {
      const parcelingData = action.payload.data
      parcelingData.id = action.meta.previousAction.payload.ID
      return { ...state, parcelingData, loader: false }
    }

    case ActionTypes.GET_RESULT_CALC_FAIL:
      return { ...state, loader: false }

    case ActionTypes.GET_URL_PAYMENT_SUCCESS:
      return { ...state, paymentUrl: action.payload.url }

    case ActionTypes.SAVE_CARD_DATA:
      return { ...state, card: action.payload }
    case ActionTypes.UPDATE_EMAIL:
    case ActionTypes.APPROVE_PAYMENT:
      return { ...state, loader: true }

    case ActionTypes.APPROVE_PAYMENT_FAIL:
      return { ...state, approved: false, loader: false }

    case ActionTypes.APPROVE_PAYMENT_SUCCESS:
      return {
        ...state,
        approved: true,
        loader: false,
        result: action.payload.data
      }

    case ActionTypes.SET_PARCELING:
      return {
        ...state,
        dueDateOptions: [],
        numberPlots: null,
        parcelingData: null,
        error: false,
        closeModal: action.payload
      }

    case ActionTypes.SET_PARCELING_DATA:
      return { ...state, parcelingData: null, dueDateOptions: [] }

    case ActionTypes.ERROR_CALC:
      return {
        ...state,
        dueDateOptions: [],
        numberPlots: null,
        loader: false,
        error: true,
        errorCalc: true
      }

    case ActionTypes.GET_NEGOTIATION_LOGS:
      return { ...state, loader: true }

    case ActionTypes.GET_NEGOTIATION_LOGS_SUCCESS:
      return {
        ...state,
        loader: false,
        negotiationLogs: action.payload.data,
        isFiltering: false
      }

    case ActionTypes.GET_NEGOTIATION_LOGS_FAIL:
      return {
        ...state,
        loader: false,
        isFiltering: false,
        negotiationLogsError: true
      }

    case ActionTypes.FILTER_NEGOTIATION_LOGS:
      return { ...state, isFiltering: true }

    case ActionTypes.FILTER_NEGOTIATION_LOGS_SUCCESS:
      return {
        ...state,
        isFiltering: false,
        negotiationLogs: action.payload.data
      }

    case ActionTypes.FILTER_NEGOTIATION_LOGS_FAIL:
      return { ...state, isFiltering: false }

    case ActionTypes.EMIT_BILLET:
      return { ...state }

    case ActionTypes.EMIT_BILLET_SUCCESS:
      return { ...state, loader: false, billetResult: action.payload }

    case ActionTypes.EMIT_BILLET_FAIL:
      return { ...state, loader: false }

    case ActionTypes.CLOSE_EMIT_FAIL_MODAL:
      return { ...state, emitBilletError: false }

    default:
      return state
  }
}

function formatProducts(payload) {
  return (
    is(Array, payload) &&
    payload.map(({ product, invoices }) => ({
      label: product,
      value: invoices[0].productId
    }))
  )
}

function formatNumberPlots(payload) {
  const plots = []
  for (const item in payload) {
    const obj = {
      label: payload[item],
      value: payload[item]
    }
    plots.push(obj)
  }
  return plots
}

function formatInstallmentsOptions(payload) {
  const installmentOptions = []
  payload.installmentOptions.map((item, index) => {
    let label = item.replace("ENTRY_", "Entrada + ")
    label = label.replace("_PLOT", ` parcela${index > 1 ? "s" : ""}`)
    label = label.replace("UNIQUE", "À vista")

    let value = item.replace("ENTRY_", "")
    value = value.replace("_PLOT", "")
    const obj = {
      label,
      value
    }
    return installmentOptions.push(obj)
  })
  return installmentOptions
}

function formatDateOptions(payload) {
  const dateOptions = []
  payload.dueDateOptions.map((item) => {
    const obj = {
      label: item,
      value: item
    }
    return dateOptions.push(obj)
  })
  return dateOptions
}



// WEBPACK FOOTER //
// ./src/services/state/negotiation/reducer.js